import { mdiPlus } from '@mdi/js';
import { Box, FormHelperText, Typography } from '@mui/material';
import { BoxProps } from '@mui/system';

import { ActionButton } from 'common/components/ActionButton';
import { Icon } from 'common/components/Icon';
import { withSxProp } from 'common/utils/props';

interface IProps extends BoxProps {
    children?: string;
    disabled?: boolean;
    error?: string;
    onClick?(
        e:
            | React.MouseEvent<HTMLDivElement>
            | React.KeyboardEvent<HTMLDivElement>
    ): void;
}

export const AddButton = ({
    'aria-label': ariaLabel,
    children,
    disabled,
    error,
    sx,
    onClick,
    ...other
}: IProps) => (
    <Box
        sx={[
            {
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                alignSelf: 'flex-start',
            },
            ...withSxProp(sx),
        ]}
        onClick={(e) => !disabled && onClick?.(e)}
        onKeyDown={(e) => {
            if (e.key !== 'Enter' || disabled) return;

            onClick?.(e);
        }}
        {...other}
    >
        {children && (
            <Box
                sx={{
                    mr: 1.5,
                    position: 'relative',
                    color: disabled ? 'grey.400' : 'text.primary',
                }}
            >
                <Typography fontSize="1.8rem" fontWeight="700">
                    {children}
                </Typography>

                {!!error && (
                    <Box sx={{ mt: '-5px', position: 'absolute' }}>
                        <FormHelperText error>{error}</FormHelperText>
                    </Box>
                )}
            </Box>
        )}

        <ActionButton
            outlined
            sizeSm
            aria-label={ariaLabel}
            component={Box}
            disabled={disabled}
        >
            <Icon path={mdiPlus} />
        </ActionButton>
    </Box>
);
